<template>
    <form @submit.prevent="onRecipientsSubmit">
        <h2 class="h6">Powiadomienia SMS</h2>
        <p class="text-sm mb-4">
            Poniżej możesz ustalić do 5 numerów, na które będą przesyłane
            wszystkie powiadomienia SMS.
        </p>

        <template v-if="localRecipients.length > 0">
            <div
                v-for="(rec, idx) in localRecipients"
                :key="idx"
                class="
                    cux-exclude
                    single-recipient
                    d-flex
                    justify-content-around
                    align-items-center
                    mb-4
                "
            >
                <div class="flex-grow-1 row">
                    <phone-input
                        class="col-md-6"
                        :id="`mp-phone${idx}`"
                        :name="`mp-phone${idx}`"
                        :phone-value="rec.phone"
                        :invalid-phone="rec.valid_phone === false"
                        :readonly="!!rec.created_at"
                        placeholder="Nr telefonu"
                        @setInvalidPhoneValue="
                            val => setInvalidPhoneValue(val, idx)
                        "
                        @onChange="changePhone($event, idx)"
                    ></phone-input>
                    <the-input
                        :id="`mp-phone-name${idx}`"
                        class="col-md-6 name-input"
                        type="text"
                        label="Nazwa"
                        :name="`mp-phone-name${idx}`"
                        @input="changeName($event, idx)"
                        :text="rec.name"
                        :readonly="!!rec.created_at"
                        :invalid="rec.valid_name === false"
                        invalid-feedback="To pole nie może być puste"
                    ></the-input>
                </div>
                <div class="ml-4">
                    <v-popover
                        placement="right"
                        offset="16"
                        :class="rec.id ? 'visible' : 'invisible'"
                    >
                        <button type="button" class="btn btn-sm btn-auto">
                            <a-icon icon="Close" class="card__input-icon" />
                        </button>

                        <template slot="popover">
                            <popover-confirm
                                @confirmed="
                                    onRecipientRemoveClick(
                                        recipients[idx] && recipients[idx].id
                                    )
                                "
                            />
                        </template>
                    </v-popover>
                </div>
            </div>
        </template>

        <button
            :disabled="unsavedRecipients.length === 0"
            class="btn btn-block btn-secondary"
            type="submit"
        >
            Zapisz zmiany
        </button>
    </form>
</template>

<script>
export default {
    name: 'Recipients',
    data() {
        return {
            phoneAmount: 5,
            unsavedRecipients: [],
            localRecipients: []
        }
    },
    watch: {
        recipients: {
            immediate: true,
            handler() {
                this.setLocalRecipients()
                this.setUnsavedRecipients()
            }
        }
    },
    computed: {
        recipients() {
            return this.$store.getters.getRecipients
        }
    },
    methods: {
        setUnsavedRecipients() {
            this.unsavedRecipients = this.localRecipients.filter(
                (recipient, recipientIdx) => {
                    recipient.recipientIdx = recipientIdx
                    return (
                        !recipient.id &&
                        recipient.phone &&
                        !recipient.created_at &&
                        recipient.valid_phone !== false &&
                        recipient.valid_name !== false
                    )
                }
            )
        },
        setLocalRecipients() {
            const recipients = []

            for (let i = 0; i < this.phoneAmount; i++) {
                if (this.recipients[i]) {
                    recipients.push(this.recipients[i])
                }
            }

            this.localRecipients = recipients
        },
        async onRecipientRemoveClick(id) {
            const deleteResponse = await this.$store.dispatch(
                'deleteRecipient',
                id
            )
            if (
                deleteResponse &&
                deleteResponse.data &&
                deleteResponse.data.message === 'OK'
            ) {
                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Pomyślnie usunięto'
                })
            } else {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd. Spróbuj ponownie później.'
                })
            }
        },
        onRecipientsSubmit() {
            this.unsavedRecipients.forEach(async recipient => {
                if (!!recipient.phone && !recipient.name.length) {
                    recipient.valid_name = false
                    this.setUnsavedRecipients()
                    return
                }
                try {
                    const response = await this.$store.dispatch(
                        'recipientAdd',
                        recipient
                    )
                    if (response.data && response.data.data) {
                        let notificationType
                        let notificationContent
                        if (response.data.data.phone) {
                            notificationType = 'success'
                            notificationContent = `Zapisano numer telefonu: ${this.$options.filters.formatPhone(
                                response.data.data.phone
                            )}`
                        } else {
                            notificationType = 'danger'
                            notificationContent = 'Błąd zapisu'
                            if (response.data.data.errors) {
                                let errorMessage = ''

                                Object.entries(
                                    response.data.data.errors
                                ).forEach(entry => {
                                    const errorField = entry[0]
                                    let fieldName = ''
                                    switch (errorField) {
                                    case 'name':
                                        fieldName = 'Nazwa: '
                                        break
                                    case 'phone':
                                        fieldName = 'Telefon: '
                                        break
                                    default:
                                        break
                                    }

                                    errorMessage += fieldName
                                    entry[1].forEach((error, errorIdx) => {
                                        errorMessage += error.message
                                        if (errorIdx === entry[1].length - 1) {
                                            errorMessage += '. '
                                        } else {
                                            errorMessage += ', '
                                        }
                                    })
                                })

                                notificationContent = `Błąd zapisu: ${errorMessage}`
                            }
                        }
                        this.$store.dispatch('addNotification', {
                            type: notificationType,
                            content: notificationContent
                        })
                    }
                } catch {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd. Spróbuj ponownie później'
                    })
                }
            })
        },
        setInvalidPhoneValue(val, idx) {
            this.localRecipients[idx].valid_phone = !val
            this.setUnsavedRecipients()
        },
        changePhone(event, idx) {
            this.localRecipients[idx].phone = event?.replaceAll(/[-\s]/g, '')
            this.setUnsavedRecipients()
        },
        changeName(event, idx) {
            this.localRecipients[idx].name = event
            if (!!event && this.localRecipients[idx].valid_name === false) {
                this.localRecipients[idx].valid_name = true
            }
            this.setUnsavedRecipients()
        }
    },
    beforeDestroy() {
        this.$store.dispatch('clearRecipients')
    }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.single-recipient {
    @include media-breakpoint-down(sm) {
        padding: 0.5rem;
    }

    .form-group {
        margin-bottom: 0;
    }
    .name-input {
        @include media-breakpoint-down(sm) {
            margin-top: 10px;
        }
    }
}
</style>
